module.exports = __webpack_public_path__ + "img/carNodata.837114e3.png";